import styled from 'styled-components'
import { colors } from 'styling/GlobalStyles'

export const AnalyticsPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`

export const AnalyticsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const DateDropdown = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.colorOrange};
  border-radius: 10px;
  background: transparent;
  color: ${(props) => props.theme.textColor};
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;

  svg {
    fill: ${(props) => props.theme.textColor};
  }
`

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.colorLightGray};
  border-radius: 10px;
  background: transparent;
  color: ${(props) => props.theme.textColor};
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;

  svg {
    fill: ${(props) => props.theme.textColor};
  }
`

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.colorOrange};
  border-radius: 10px;
  background: transparent;
  color: ${(props) => props.theme.colorOrange};
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  svg {
    fill: ${(props) => props.theme.colorOrange};
  }
`

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1rem;
  border: 1px solid ${(props) => props.theme.colorGreen};
  border-radius: 10px;
  background: ${(props) => props.theme.colorGreen}15;
  width: 100%;
`

export const BannerLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${(props) => props.theme.colorGreen};
  font-size: 0.8rem;
  font-weight: 500;
`

export const BannerRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const BannerChip = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.theme.greyText};
`

export const BannerClose = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.greyText};
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0;
`

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`

export const KpiRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`

export const KpiCardWrapper = styled.div<{ accentColor?: string }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  ${(props) => props.theme.content};
  border-left: 3px solid ${(props) => props.accentColor || props.theme.colorOrange};
  min-height: 5rem;
`

export const KpiIcon = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color || props.theme.colorOrange};

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${(props) => props.color || props.theme.colorOrange};
  }
`

export const KpiContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1;
`

export const KpiValue = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  color: ${(props) => props.theme.textColor};
`

export const KpiLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  color: ${(props) => props.theme.greyText};
`

export const KpiSublabel = styled.div`
  font-size: 0.65rem;
  color: ${(props) => props.theme.greyText};
`

export const KpiTrend = styled.div<{ positive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${(props) => (props.positive ? props.theme.colorGreen : props.theme.colorRed)};
  margin-left: auto;
  white-space: nowrap;
`

export const ChartCardWrapper = styled.div`
  ${(props) => props.theme.content};
  border-radius: 10px;
  padding: 1.25rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ChartCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const ChartCardTitle = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: ${(props) => props.theme.textColor};
`

export const ChartCardControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const PeriodToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  border-radius: 0.8rem;
  overflow: hidden;
  background: ${(props) => props.theme.colorSurface2};
`

export const PeriodButton = styled.button<{ active?: boolean }>`
  padding: 0.375rem 0.75rem;
  border: none;
  border-radius: 0.8rem;
  font-size: 0.75rem;
  font-weight: ${(props) => (props.active ? '700' : '400')};
  color: ${(props) => (props.active ? '#fff' : props.theme.colorTextFaded)};
  background: ${(props) => (props.active ? props.theme.colorOrange : 'transparent')};
  cursor: pointer;
  transition: all 0.2s;
`

export const ChartLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.7rem;
  color: ${(props) => props.theme.greyText};
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`

export const LegendDot = styled.div<{ color: string; dashed?: boolean }>`
  width: ${(props) => (props.dashed ? '1.25rem' : '0.5rem')};
  height: ${(props) => (props.dashed ? '2px' : '0.5rem')};
  border-radius: ${(props) => (props.dashed ? '0' : '50%')};
  background: ${(props) => (props.dashed ? 'transparent' : props.color)};
  ${(props) => props.dashed && `border-top: 2px dashed ${props.color};`}
`

export const SubTabBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
`

export const SubTabItem = styled.button<{ active?: boolean }>`
  flex: 1;
  padding: 0.625rem 1rem;
  height: 48px;
  border: none;
  background: ${(props) => (props.active ? colors.paleOrange : props.theme.colorSurface1)};
  color: ${(props) => (props.active ? '#fff' : props.theme.colorTextFaded)};
  font-size: 0.875rem;
  font-weight: ${(props) => (props.active ? '700' : '400')};
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  border-bottom: 1px solid
    ${(props) => (props.active ? colors.orange : props.theme.colorDividerDefault)};

  &:hover {
    color: ${(props) => (props.active ? '#fff' : props.theme.textColor)};
  }
`

export const AnalyticsTableWrapper = styled.div`
  width: 100%;
  padding: 0 1rem;
  ${(props) => props.theme.content};
  border-radius: 10px;
  overflow: hidden;
`

export const TableHeaderCell = styled.div<{ sortable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  cursor: ${(props) => (props.sortable ? 'pointer' : 'default')};
  user-select: none;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.greyText};
`

export const SortIcon = styled.span<{ direction?: 'asc' | 'desc' | null }>`
  display: inline-flex;
  font-size: 0.6rem;
  color: ${(props) => (props.direction ? props.theme.colorOrange : props.theme.colorLightGray)};
`

export const RateCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`

export const RateBar = styled.div<{ percent: number; color: string }>`
  position: relative;
  height: 4px;
  border-radius: 2px;
  background: #E5E5E5;
  flex: 1;
  max-width: 80%;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    min-width: 6px;
    width: ${(props) => Math.max(0, Math.min(100, props.percent))}%;
    background: ${(props) => props.color};
    border-radius: 2px;
  }
`

export const RateValue = styled.span<{ color: string }>`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${(props) => props.color};
  white-space: nowrap;
`

export const LockedCard = styled.div`
  ${(props) => props.theme.content};
  border-radius: 10px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  min-height: 12rem;
`

export const LockedIcon = styled.div`
  color: ${(props) => props.theme.greyText};
  font-size: 2rem;

  svg {
    width: 2.5rem;
    height: 2.5rem;
    fill: ${(props) => props.theme.greyText};
  }
`

export const InfoBanner = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: ${(props) => props.theme.colorSurface1};
  font-size: 0.8rem;
  color: ${(props) => props.theme.greyText};
  width: 100%;
`

export const OverviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
`

export const OverviewCard = styled.div`
  ${(props) => props.theme.content};
  border-radius: 10px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &:hover {
    outline: 1px solid ${(props) => props.theme.colorOrange};
  }
`

export const OverviewCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const OverviewCardIcon = styled.div<{ color?: string }>`
  color: ${(props) => props.color || props.theme.colorOrange};

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${(props) => props.color || props.theme.colorOrange};
  }
`

export const OverviewCardValue = styled.div<{ color?: string }>`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${(props) => props.color || props.theme.colorGreen};
`

export const HorizontalBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

export const HorizontalBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

export const HorizontalBarLabel = styled.div`
  font-size: 0.8rem;
  color: ${(props) => props.theme.textColor};
  min-width: 7rem;
  text-align: right;
`

export const HorizontalBarTrack = styled.div`
  flex: 1;
  height: 1.25rem;
  background: ${(props) => props.theme.colorSurface1};
  border-radius: 4px;
  overflow: hidden;
`

export const HorizontalBarFill = styled.div<{ percent: number; color?: string }>`
  height: 100%;
  width: ${(props) => props.percent}%;
  background: ${(props) => props.color || props.theme.colorOrange};
  border-radius: 4px;
  transition: width 0.3s ease;
`

export const HorizontalBarValue = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  min-width: 3.5rem;
  text-align: right;
`

export const StatusBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

export const StatusBar = styled.div`
  display: flex;
  width: 100%;
  height: 2rem;
  border-radius: 6px;
  overflow: hidden;
`

export const StatusSegment = styled.div<{ percent: number; color: string }>`
  width: ${(props) => props.percent}%;
  background: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
  color: #fff;
  min-width: ${(props) => (props.percent > 5 ? 'auto' : '0')};
  overflow: hidden;
`

export const StatusLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.7rem;
  color: ${(props) => props.theme.greyText};
`

export const LogisticsSubTabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const LogisticsSubTab = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.8rem;
  font-size: 0.875rem;
  font-weight: ${(props) => (props.active ? '700' : '400')};
  color: ${(props) => (props.active ? '#fff' : props.theme.colorTextFaded)};
  background: ${(props) => (props.active ? props.theme.colorOrange : 'transparent')};
  cursor: pointer;
  transition: all 0.2s;

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${(props) => (props.active ? '#fff' : props.theme.colorTextFaded)};
  }
`
